import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { tagBackgroundColor, titles, white } from '../../../styles/colors';
import { CssSelectors } from '../../../styles/styles';

const { spacing } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		boxSizing: 'border-box',
		width: '100%',
		height: '100%',
		paddingTop: spacing.lg,
	},
	loadingRow: {
		height: 300,
	},
	drawerContainer: {
		backgroundColor: white,
		height: '100%',
		padding: `${spacing.md}px ${spacing.lg}px`,
		width: '100%',
	},
	dataBoardContainer: {
		backgroundColor: 'transparent',
	},
	drawerSection: {
		paddingRight: spacing.md,
	},
	sectionTitle: {
		color: titles,
		fontSize: 14,
		margin: '20px 0 5px 0',
	},
	banner: {
		alignItems: 'center',
		background: tagBackgroundColor,
		display: 'flex',
		padding: '1rem 0.5rem',
		gap: 12,
	},
	bannerLink: {
		alignItems: 'center',
		color: THEME.colors.primary.main,
		display: 'inline-flex',
		gap: 12,
		fontWeight: 600,
		fontSize: 14,
		textDecoration: 'none',
	},
	bannerLinkText: {
		[`@media (max-width: ${THEME.breakpoints.xxl}px)`]: {
			display: 'none',
		},
	},
	viewOnlyBadge: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: spacing.xs,
		background: THEME.colors.background.dark,
		border: `1px solid ${THEME.colors.border.main}`,
		borderRadius: THEME.common.borderRadius,
		padding: `${spacing.xs}px ${spacing.md}px`,
		fontSize: 13,
		fontWeight: 500,
		width: 'fit-content',
		color: titles,
		cursor: 'default',
		[`@media (max-width: ${THEME.breakpoints.xxl}px)`]: {
			border: 'unset',
			borderRadius: 0,
			padding: spacing.xs,
			flexDirection: 'column',
			gap: 0,
			...CssSelectors.allDescendants({ paddingTop: 8 }, 'svg'),
		},
	},
	viewOnlyBadgeText: {
		color: THEME.colors.text.dark,
		[`@media (max-width: ${THEME.breakpoints.xxl}px)`]: {
			width: 72,
			height: '100%',
			display: 'flex',
			alignItems: 'center',
			textAlign: 'center',
		},
	},
	viewOnlyContainer: {
		flexGrow: 1,
		display: 'flex',
		justifyContent: 'flex-end',
		[`@media (max-width: ${THEME.breakpoints.xxl}px)`]: {
			flexGrow: 0,
			height: 72,
		},
	},
});
